import { generateUUID } from "../uuid.ts";

/**
 * Generate a new webchat session key with a unique UUID.
 * Format: agent:main:webchat:<uuid>
 *
 * The gateway auto-creates the session when the first message is sent,
 * so no explicit session creation RPC is needed.
 */
export function createConversationKey(): string {
  return `agent:main:webchat:${generateUUID()}`;
}
